import cn from "classnames";
import React from "react";

import classes from "./style.module.css";

type TButtonProps = {
  title?: string;
  value: number;
  disabled: boolean;
  handleClick: (
    event: React.SyntheticEvent<HTMLDivElement>,
    value: number
  ) => void;
};
export const Button = ({
  value,
  disabled,
  handleClick,
  title,
}: TButtonProps) => {
  return (
    <div
      onClick={(event) => handleClick(event, value)}
      className={cn([classes.buyInternetTimeButtonValue, classes.opacity], {
        [classes.buyInternetTimeButtonValue_disable]: disabled,
      })}
    >
      {value || title}
    </div>
  );
};
